module.exports = __webpack_public_path__ + "Roboto-Black.44236ad507eddcbfd986.ttf";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/roboto-fontface/fonts/roboto/Roboto-Black.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Black.ttf
// module chunks = styles